<template lang="html">
<div>
  <div class="bg-animated text-white flex space-y-8 flex-col h-screen w-full items-center justify-center fixed top-0" v-show="isLoading" style="z-index: 100">
     <div class="h-16 rounded-md overflow-hidden text-center">
         <img src="/images/logo-mirror.svg" class="object-contain h-full inline-flex" />
     </div>
    <div class="text-4xl font-bold">
       Loading
   </div>
    <!-- Spinning semi-circle -->
    <svg class="block animate-spin h-8 w-8 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  	  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
  	  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  </div>	
  <div v-show="!isLoading">
  <!-- Navigation -->
  <div class="pt-3 sm:pt-4">
    <!-- Dropdown menu on small screens -->
    <div class="sm:hidden">
      <label for="selected-tab" class="sr-only">Select a tab</label>
      <select id="selected-tab" name="selected-tab" class="form-input" v-model="activeTab">
        <option value="shoot" selected>Shoot</option>
        <option value="review" v-if="isMirrorPlus">Review</option>
        <option value="settings">Settings</option>
      </select>
    </div>
    <!-- Tabs at small breakpoint and up -->
    <div class="hidden sm:block">
      <nav class="-mb-px border-b dark:border-gray-700">
        <div class="flex justify-between max-w-screen-xl w-full mx-auto">
          <div class="flex space-x-8">
            <!-- Current: "border-blue-500 text-blue-600", Default: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" -->
            <button data-tippy-content="The main tab for your session" @click="activeTab = 'shoot'"
                    class="border-transparent text-gray-500 hover:text-gray-700 dark:hover:text-gray-100 hover:border-gray-300 whitespace-nowrap pb-2 px-1 border-b-2 font-medium text-sm"
                    :class="{'border-blue-500 text-blue-600 dark:text-blue-300' : activeTab == 'shoot'}" aria-current="page">
              <!-- Videocamera icon -->
              <svg class="h-4 w-4 mr-1 text-gray-400 fill-current inline" xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 20 20">
                <path
                  d="M10.5 10a2.5 2.5 0 1 1-5.001-.001A2.5 2.5 0 0 1 10.5 10zM16 4v12c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2zm-3.5 6a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0zm6.715-4.914L17 6.562v7l2.215 1.477a.505.505 0 0 0 .785-.42V5.506a.505.505 0 0 0-.785-.42z"/>
              </svg>
              Shoot
            </button>
            <button data-tippy-content="Review all your takes" @click="activeTab = 'review'"
                    class="border-transparent text-gray-500 hover:text-gray-700 dark:hover:text-gray-100 hover:border-gray-300 whitespace-nowrap pb-2 px-1 border-b-2 font-medium text-sm"
                    :class="{'border-blue-500 text-blue-600 dark:text-blue-300' : activeTab == 'review'}" v-if="isMirrorPlus">
              <!-- Movie film icon -->
              <svg class="h-4 w-4 mr-1 text-gray-400 fill-current inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path
                  d="M0 4c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm6 0v12h8V4H6zM2 5v2h2V5H2zm0 4v2h2V9H2zm0 4v2h2v-2H2zm14-8v2h2V5h-2zm0 4v2h2V9h-2zm0 4v2h2v-2h-2zM8 7l5 3-5 3V7z"/>
              </svg>
              Review
            </button>
            <button data-tippy-content="Change your session settings." @click="activeTab = 'settings'"
                    class="border-transparent text-gray-500 hover:text-gray-700 dark:hover:text-gray-100  hover:border-gray-300 whitespace-nowrap pb-2 px-1 border-b-2 font-medium text-sm"
                    :class="{'border-blue-500 text-blue-600 dark:text-blue-300': activeTab == 'settings'}">
              <!-- Cog icon -->
              <svg class="h-4 w-4 mr-1 text-gray-400 fill-current inline" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path fill-rule="evenodd"
                      d="M12 4C11.4477 4 11 4.44772 11 5C11 6.69226 8.95399 7.53974 7.75738 6.34314C7.36686 5.95261 6.73369 5.95261 6.34317 6.34314C5.95265 6.73366 5.95265 7.36683 6.34317 7.75735C7.53982 8.954 6.69223 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13C6.69236 13 7.53964 15.0461 6.34311 16.2426C5.95258 16.6332 5.95258 17.2663 6.34311 17.6569C6.73363 18.0474 7.3668 18.0474 7.75732 17.6569C8.9539 16.4603 11 17.3077 11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19C13 17.3077 15.046 16.4602 16.2427 17.6568C16.6332 18.0474 17.2664 18.0474 17.6569 17.6568C18.0474 17.2663 18.0474 16.6332 17.6569 16.2426C16.4603 15.0461 17.3077 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C17.3078 11 16.4601 8.95405 17.6568 7.75737C18.0473 7.36684 18.0473 6.73368 17.6568 6.34315C17.2663 5.95263 16.6331 5.95263 16.2426 6.34315C15.046 7.53979 13 6.69219 13 5C13 4.44772 12.5523 4 12 4ZM9.00816 4.77703C9.12224 3.2243 10.4181 2 12 2C13.5819 2 14.8778 3.2243 14.9918 4.77703C16.1704 3.75977 17.9525 3.8104 19.071 4.92894C20.1896 6.04748 20.2402 7.82955 19.2229 9.00816C20.7757 9.12221 22 10.4181 22 12C22 13.5819 20.7757 14.8778 19.223 14.9918C20.2403 16.1704 20.1896 17.9525 19.0711 19.0711C17.9525 20.1896 16.1705 20.2402 14.9918 19.2229C14.8778 20.7757 13.5819 22 12 22C10.4181 22 9.12221 20.7757 9.00816 19.2229C7.82955 20.2402 6.04745 20.1896 4.92889 19.0711C3.81034 17.9525 3.75972 16.1704 4.77702 14.9918C3.2243 14.8778 2 13.5819 2 12C2 10.4181 3.22433 9.12221 4.77709 9.00816C3.75978 7.82955 3.81041 6.04747 4.92896 4.92892C6.0475 3.81038 7.82955 3.75975 9.00816 4.77703Z"
                      clip-rule="evenodd"/>
                <path fill-rule="evenodd"
                      d="M12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10ZM9.17157 9.17157C9.92172 8.42143 10.9391 8 12 8C13.0609 8 14.0783 8.42143 14.8284 9.17157C15.5786 9.92172 16 10.9391 16 12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16C10.9391 16 9.92172 15.5786 9.17157 14.8284C8.42143 14.0783 8 13.0609 8 12C8 10.9391 8.42143 9.92172 9.17157 9.17157Z"
                      clip-rule="evenodd"/>
              </svg>
              Settings
            </button>
          </div>
          <div>
            <div class="text-green-800 dark:text-green-600 px-2 py-1 rounded-md inline-flex space-x-2 items-center hidden relative" id="private-mode-badge" data-tippy-content="You are part of the private room, you can only talk to the other directors and the host.">
              <div class="h-3 w-3 rounded-full bg-green-800 dark:bg-green-500"></div>
              <div>
                Private mode
              </div>
            </div>
            <div class="text-green-800 dark:text-green-600 px-2 py-1 rounded-md inline-flex space-x-2 items-center hidden relative" id="on-set-talk-badge"
                   data-tippy-content="A member of your Production team is now speaking to the actors or crew on the set">
              <div class="h-3 w-3 rounded-full bg-green-800 dark:bg-green-500"></div>
              <div>
                On-set talk
              </div>
            </div>
          </div>

          <div class="mb-2">
            <div v-if="!roomActivated || timeRemaining <= 300000" class="space-x-2">
              <a href="/" class="underline"  data-turbolinks="false">Home</a>
              <button class="btn btn-primary text-sm px-8 pulse-halo" @click="showActivationModal = true">Activate
              </button>
            </div>
            <div class="flex space-x-2" v-if="roomActivated">
              <div>
                Time remaining:
              </div>
              <div class="font-mono">
                {{
                `${parseInt(timeRemaining / 1000 / 60 / 60)}`.padStart(2, '0')
                }}:{{
                `${parseInt(timeRemaining / 1000 / 60 % 60)}`.padStart(2, '0')
                }}:{{ `${parseInt(timeRemaining / 1000 % 60)}`.padStart(2, '0') }}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
  <!-- Main flex -->
  <main class="grid grid-cols-2 lg:grid-cols-5 mx-auto max-w-screen-xl mt-6 gap-4 px-4 lg:px-0"
        v-show="activeTab == 'shoot'">
    <!-- Shooting plan/board well -->
    <div class="lg:col-span-1 order-5 lg:order-1 xl:h-128 relative pb-2" style="height: 35rem;">
      <!-- Shooting board -->
      <shooting-board ref="shootingBoard" :is-guest="false" v-show="showShootingBoard"></shooting-board>
	    <!-- Shooting Plan -->
      <mirror-shooting-plan ref="shootingPlan" v-show="!showShootingBoard" v-if="shootingPlanEnabled"></mirror-shooting-plan>
	    <button class="btn btn-secondary absolute left-0 bottom-0 w-full" @click="showShootingBoard = !showShootingBoard" v-if="shootingPlanEnabled">
		    {{ showShootingBoard ? "Shooting plan" : "Shooting board" }}
	    </button>
    </div>
    <!-- Viewport -->
    <div class="lg:col-span-3 col-span-2 order-1 lg:order-2">
      <viewport ref="viewport" @create-take-folder="$refs.videoTakeList.showCreateFolderModal = true"
                :isHighDataModeOn="isHighDataModeOn" :demoModeOn="demoModeOn" :room-activated="roomActivated" :tempHideCamera="tempHideCamera" :isMirrorPlus="isMirrorPlus"
                :sessionSuspended="isSuspended"></viewport>
    </div>
    <!-- Participants  -->
    <div class="lg:col-span-1 order-6 lg:order-3 flex flex-col space-y-2 h-64 xl:h-128" style="height: 35rem;">
      <div class="flex text-base justify-between">
        <div class="text-lg font-medium">
          Participants <span class="text-gray-500 text-sm">–</span>  <span class="text-gray-500 text-sm" v-html="$refs && $refs.participantList && $refs.participantList.connected_peers.length"></span>
        </div>
        <a rel="nofollow" @click="showManageParticipantsModal()"
           class="block text-blue-200 hover:bg-transparent rounded-md dark:text-gray-500 dark:hover:text-gray-700 hover:text-blue-500 cursor-pointer underline text-right"
           data-e2e="manage_test">
          Manage
        </a>
      </div>
      <mirror-participant-list ref="participantList" :is-host="true" class="flex-grow" style="height: 26rem">
      </mirror-participant-list>
      <div class="pt-2">
        <push-to-talk ref="ptt"></push-to-talk>
      </div>
    </div> <!-- Guests END  -->
    <!-- Continuity -->
    <div class="lg:col-span-1 order-3 lg:order-4 mt-4" v-if="isMirrorPlus">
      <div class="font-medium text-lg mt-3">
        Continuity
      </div>
      <continuity ref="continuity" class="mt-2"></continuity>
    </div> <!-- Continuity end -->
    <!-- Takes -->
    <div class="lg:col-span-3 col-span-2 order-2 lg:order-5 h-64 xl:h-120 mt-4" v-if="isMirrorPlus">
      <video-take-list :is-director="false" :is-controller="true" ref="videoTakeList" :roomKey="room.key" :demoModeOn="demoModeOn" @goBackLive="tempHideCamera = false" @loadClipPlayback="tempHideCamera = true" :video-leader-enabled="videoLeaderEnabled"></video-take-list>
    </div> <!-- Takes END -->
    <div class="order-4 lg:order-6 mt-4 pb-10"
	       :class="isMirrorPlus ? 'lg:col-span-1' : 'lg:col-span-5'"
	       style="height: 32.5rem;">
      <stills ref="stills" :is-in-host="true" :isMirrorPlus="isMirrorPlus"
		          :gridSize="isMirrorPlus ? 'gap-2 grid-cols-4' : 'gap-4 grid-cols-20' "></stills>
    </div> <!-- Stills end -->
  </main> <!-- MainFlex END -->
  <!-- Review -->
  <div v-show="activeTab == 'review'">
      <div class="mx-auto max-w-screen-xl pt-10">
        <video-take-list ref="reviewVideoTakeList" :video-leader-enabled="videoLeaderEnabled" :is-director="false" :is-controller="false"
    :demoModeOn="demoModeOn" @goBackLive="tempHideCamera = false" @loadClipPlayback="tempHideCamera = true" :roomKey="room.key">
  </video-take-list>
    </div>
  </div>
  <!-- Settings -->
  <div id="settings" v-show="activeTab == 'settings'">
    <mirror-settings ref="settings"
                     @switchAuxCamera="tempHideCamera = $event"
                     @lowDataModeOn="isHighDataModeOn = !$event" @demoModeOn="demoModeOn = $event"
                     :hooks-enabled="hooksEnabled"
                     :dark-mode-enabled="darkModeEnabled" :room="room"></mirror-settings>
    <audio id="localAudio" class="hidden"></audio>
    <audio id="localAudio2" class="hidden" autoplay></audio>
    <audio id="localAudio3" class="hidden" muted></audio>
  </div>
  <!-- Chat -->
  <chat ref="chat"></chat>
  <!-- Tasks (this shows stuff like connecting to server) -->
  <div class="fixed right-0 bottom-0 px-5 bg-white dark:bg-gray-800 shadow-lg border rounded-md status-indicator" style="z-index: 100;">
    <div class="tasks"></div>
  </div>
  </div> <!-- End of wrapper for loading -->

  <!-- Activation modal -->
  <modal :showModal="showActivationModal" @close="showActivationModal = false">
    <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
      <!-- Upload cloud icon -->
      <svg class="h-6 w-6 text-green-600 fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24">
        <path fill-rule="evenodd"
              d="M11 4C8.79082 4 7 5.79085 7 8C7 8.03242 7.00047 8.06627 7.00131 8.10224C7.01219 8.56727 6.70099 8.97839 6.25047 9.09416C4.95577 9.42685 4 10.6031 4 12C4 13.6569 5.34317 15 7 15H8C8.55228 15 9 15.4477 9 16C9 16.5523 8.55228 17 8 17H7C4.23861 17 2 14.7614 2 12C2 9.93746 3.2482 8.16845 5.02926 7.40373C5.32856 4.36995 7.88746 2 11 2C13.2236 2 15.1629 3.20934 16.199 5.00324C19.4207 5.10823 22 7.75289 22 11C22 14.3137 19.3138 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C18.2092 15 20 13.2091 20 11C20 8.79085 18.2092 7 16 7C15.8893 7 15.78 7.00447 15.6718 7.01322C15.2449 7.04776 14.8434 6.8066 14.6734 6.4135C14.0584 4.99174 12.6439 4 11 4ZM11.2929 9.29289C11.6834 8.90237 12.3166 8.90237 12.7071 9.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071C14.3166 13.0976 13.6834 13.0976 13.2929 12.7071L13 12.4142V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V12.4142L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071C8.90237 12.3166 8.90237 11.6834 9.29289 11.2929L11.2929 9.29289Z"
              clip-rule="evenodd"/>
      </svg>
    </div>
    <div class="mt-3 text-center sm:mt-5">
      <h3 class="text-lg leading-6 font-medium text-gray-900 dark:text-gray-100" id="modal-headline">
        Activate session
      </h3>
      <div class="mt-2">
        <p class="text-sm text-gray-500 dark:text-gray-200">
          Please, choose one of the following activations to start your session.
        </p>
      </div>
    </div>
    <div class="mt-3 text-center sm:mt-5" v-if="isInTrial && tokens.length === 0">
      <div class="mt-2">
        <p class="text-sm text-red-500">
          You run out of activations. To buy more activations consider upgrading your account
        </p>
      </div>
    </div>
    <div class="mt-5 space-x-2 text-center">
      <a href="/payment/products/mirror-tokens/purchase" class="btn btn-sm btn-primary"
         v-if="tokens.length == 0 && !isInTrial">Buy Activations</a>
      <button class="btn btn-sm btn-secondary text-sm" @click="activateRoom(t.token_id)" v-for="t in tokens">Activate
        for {{ t.token.duration }}h
      </button>
    </div>
  </modal>
  <modal :showModal="showExpirationModal" @close="showExpirationModal = false">
    <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
      <!-- Upload cloud icon -->
      <svg class="h-6 w-6 text-green-600 fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24">
        <path fill-rule="evenodd"
              d="M11 4C8.79082 4 7 5.79085 7 8C7 8.03242 7.00047 8.06627 7.00131 8.10224C7.01219 8.56727 6.70099 8.97839 6.25047 9.09416C4.95577 9.42685 4 10.6031 4 12C4 13.6569 5.34317 15 7 15H8C8.55228 15 9 15.4477 9 16C9 16.5523 8.55228 17 8 17H7C4.23861 17 2 14.7614 2 12C2 9.93746 3.2482 8.16845 5.02926 7.40373C5.32856 4.36995 7.88746 2 11 2C13.2236 2 15.1629 3.20934 16.199 5.00324C19.4207 5.10823 22 7.75289 22 11C22 14.3137 19.3138 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C18.2092 15 20 13.2091 20 11C20 8.79085 18.2092 7 16 7C15.8893 7 15.78 7.00447 15.6718 7.01322C15.2449 7.04776 14.8434 6.8066 14.6734 6.4135C14.0584 4.99174 12.6439 4 11 4ZM11.2929 9.29289C11.6834 8.90237 12.3166 8.90237 12.7071 9.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071C14.3166 13.0976 13.6834 13.0976 13.2929 12.7071L13 12.4142V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V12.4142L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071C8.90237 12.3166 8.90237 11.6834 9.29289 11.2929L11.2929 9.29289Z"
              clip-rule="evenodd"/>
      </svg>
    </div>
    <div class="mt-3 text-center sm:mt-5">
      <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline-">
        Session about to expire
      </h3>
      <div class="mt-2">
        <p class="text-sm text-gray-500">
          Your session is about to expire. Consider using another activation to avoid interrupting the session
        </p>
      </div>
    </div>
    <div class="mt-3 text-center sm:mt-5" v-if="isInTrial && tokens.length === 0">
      <div class="mt-2">
        <p class="text-sm text-red-500">
          You run out of activations. To buy more activations consider upgrading your account
        </p>
      </div>
    </div>
    <div class="mt-5 space-x-2 text-center">
      <a href="/payment/products/mirror-tokens/purchase" class="btn btn-sm btn-primary"
         v-if="tokens.length == 0 && !isInTrial">Buy Activations</a>
      <button class="btn btn-sm btn-secondary text-sm" @click="activateRoom(t.token_id)" v-for="t in tokens">Activate
        for {{ t.token.duration }}h
      </button>
    </div>
  </modal>
  <modal :showModal="showPermissionModal" @close="showPermissionModal = false" classSize="sm:max-w-2xl">
    <div v-show="permissionStep == 1">
      <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
        <!-- Upload cloud icon -->
        <svg class="h-6 w-6 text-green-600 fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
             viewBox="0 0 24 24">
          <path fill-rule="evenodd"
                d="M11 4C8.79082 4 7 5.79085 7 8C7 8.03242 7.00047 8.06627 7.00131 8.10224C7.01219 8.56727 6.70099 8.97839 6.25047 9.09416C4.95577 9.42685 4 10.6031 4 12C4 13.6569 5.34317 15 7 15H8C8.55228 15 9 15.4477 9 16C9 16.5523 8.55228 17 8 17H7C4.23861 17 2 14.7614 2 12C2 9.93746 3.2482 8.16845 5.02926 7.40373C5.32856 4.36995 7.88746 2 11 2C13.2236 2 15.1629 3.20934 16.199 5.00324C19.4207 5.10823 22 7.75289 22 11C22 14.3137 19.3138 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C18.2092 15 20 13.2091 20 11C20 8.79085 18.2092 7 16 7C15.8893 7 15.78 7.00447 15.6718 7.01322C15.2449 7.04776 14.8434 6.8066 14.6734 6.4135C14.0584 4.99174 12.6439 4 11 4ZM11.2929 9.29289C11.6834 8.90237 12.3166 8.90237 12.7071 9.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071C14.3166 13.0976 13.6834 13.0976 13.2929 12.7071L13 12.4142V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V12.4142L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071C8.90237 12.3166 8.90237 11.6834 9.29289 11.2929L11.2929 9.29289Z"
                clip-rule="evenodd"/>
        </svg>
      </div>
      <div class="mt-3 text-center sm:mt-5">
        <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
          Welcome to Mirror.
        </h3>
        <div class="mt-2">
          <p class="text-sm text-gray-500">
            Before you begin, we need to get access to your microphone and camera.
          </p>
        </div>
      </div>
      <div class="text-center mt-5" id="requestMediaPermissionsWrapper">
        Microphone is <span id="micPermissionStatus" class="text-sm"></span>
        &bull;
        Camera is <span id="videoPermissionStatus" class="text-sm"></span>
      </div>
      <div class="mt-5 space-x-2 text-center">
        <button class="btn btn-sm btn-secondary text-sm" @click="requestMediaPermissions" v-show="!permissionGranted">
          Request permissions
        </button>
      </div>
    </div>
    <div v-show="permissionStep == 2" class="px-2">
      <div class="text-2xl font-bold">
        Settings review
      </div>
      <div class="text-lg font-semibold mt-4">
        Host
      </div>
      <div class="grid grid-cols-2 gap-2 mt-2">
        <div>
          <div class="text-base font-semibold">
            Microphone
          </div>
          <select class="audioSource form-input w-full" data-id="0"></select>
        </div>
        <div>
          <div class="flex flex-wrap">
            <div class="text-base font-semibold">
              Headphones
            </div>
          </div>
          <div class="flex flex-wrap items-baseline justify-between">
            <select class="audioOutput form-input flex-1 mr-2" data-id="0"></select>
            <audio src="/audio/test_audio.mp3" id="headphoneTestAudio"></audio>
          </div>
        </div>
        <div class="col-span-2">
          <div class="flex flex-wrap">
            <div class="text-base font-semibold">
              On-set speakers
            </div>
          </div>
          <div class="flex flex-wrap items-baseline justify-between">
            <select class="audioOutput form-input flex-1 mr-2" data-id="3"></select>
          </div>
        </div>

      </div>
      <div class="text-lg font-semibold mt-4">
        Video settings
      </div>
      <div class="grid grid-cols-2 gap-2 mt-2">
        <div>
          <div class="text-base font-semibold">
            Video source
          </div>
          <select class="videoSource form-input w-full" data-id="0"></select>
        </div>
        <div>
          <div class="text-base font-semibold">
            Video's audio source
          </div>
          <select class="audioSource form-input w-full" data-id="1"></select>
        </div>
      </div>
      <p class="mt-4">
        Remember that to speak with your guests we use a Hold-to-Talk button to keep everything tidy.
      </p>
        <br/>
        <button class="btn btn-primary w-full" @click="hideSettingsModal">Everything looks ok</button>
      </div>
    </modal>
    <modal :showModal="showParticipantsModal" @close="showParticipantsModal = false" classSize="sm:max-w-2xl">
      <manage-participants @close-modal="showParticipantsModal = false"
                           :room="room" :roles="roles"
                           :is-in-trial="isInTrial" ref="manageParticipantsModal"></manage-participants>
    </modal>
    <modal :showModal="showResumeSessionModal" @close="showResumeSessionModal = false" classSize="sm:max-w-2xl">
      <h1 class="text-3xl font-bold">Resume session</h1>
      <p class="my-5">Do you want to resume the session?</p>
      <div class="flex justify-between">
        <button class="btn btn-primary" @click="unsuspendSession(false)">Resume session quietly</button>
        <button class="btn btn-secondary" @click="unsuspendSession(true)">Resume session and Notify Participants by Email</button>
        <button class="btn btn-secondary" @click="showResumeSessionModal = false">Cancel</button>
      </div>
    </modal>
  </div>
</template>
<script>
import axios from "axios";

import {detectBrowser} from 'utils/browser';
import {requestMediaPermissions, checkAVPermissions, refreshDevices} from 'webrtc/mediaDevices';
import {localNotify} from "utils/notifications";
import commandsManager from 'general/CommandsManager';
import hooksManager from 'general/HooksManager'

import MirrorParticipantList from './mirror-participant-list.vue'
import MirrorParticipant from './mirror-participant.vue'

export default {
  components:{
    MirrorParticipant,
    MirrorParticipantList,

  },
  props: {
    room: {},
    tokens: {},
    authenticity_token: {},
    name: {},
    alreadyActiveUntil: {
      type: Number
    },
    isInTrial: {},
    roles: {
      type: Array
    },
    // Feature flags
    hooksEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    videoLeaderEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    darkModeEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    shootingPlanEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    roomWasSuspended: {
      type: Boolean,
      required: true,
      default: false,
    },

  },
  data() {
    return {
      activeUntil: null,
      activeTab: 'shoot',
      roomActivated: false,
      resolution: '720p',
      microphoneSelected: '',
      heapdhonesSelected: '',
      cameraSelected: '',
      cameraAudioSelected: '',
      constraints: {},
      isHighDataModeOn: true,
      demoModeOn: false,

      showActivationModal: false,
      showExpirationModal: false,
      timeRemaining: false,

      permissionGranted: null,
      permissionStep: 1,
      showPermissionModal: false,
      permissionsNeeded: {
        audio: true,
        video: true
      },
      showParticipantsModal: false,
      tempHideCamera: false,

      showShootingBoard: true,
      isMirrorPlus: true,
      isLoading: true,
      isSuspended: false,

      showResumeSessionModal: false,
    }
  },
  mounted() {
    // when the dom is done loading set the loading to false
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        this.isLoading = false;
      }
    };

    window.refreshDevices = refreshDevices;
    var self = this;
    // set the value of active until to the passed prop
    self.activeUntil = self.alreadyActiveUntil
    self.roomActivated = self.activeUntil !== 0;
    if (self.roomActivated) {
     let endOfSessionButton = document.querySelector("#endOfSessionButton")
     if (endOfSessionButton) endOfSessionButton.classList.remove("hidden")
      this.$root.$emit('roomActivated');
    }

    this.isSuspended = this.roomWasSuspended
      // suspend room
      let suspendSessionButton = document.querySelector("#suspendSessionButton")
      if (suspendSessionButton) {
        suspendSessionButton.classList.remove("hidden")
        suspendSessionButton.addEventListener("click", this.toggleSuspendSession)
      }
      this.updateSessionButtonUI(this.isSuspended)


    self.startTimer();

      // START WEBRTC
      setupEngine('mirror_shoot', 'host', this.name, window.participant_key, this.room.key)

    // check if browser is compatible
    this.checkBrowser();

    checkAVPermissions({
      microphone: true,
      camera: true,
    }).then((granted) => {
      // this.showPermissionModal = !granted;
      this.permissionGranted = granted;
      this.showPermissionModal = true;
      this.permissionStep = granted ? 2 : 1;
    });

    window.role = 'host'
    window.authenticity_token = this.authenticity_token
    window.room = this.room.key
    window.product = 'mirror_shoot'
    window.room_key = this.room.key
    window.name = this.name
    window.activeUntil = self.activeUntil

    if (this.$refs.reviewVideoTakeList)
      this.$refs.reviewVideoTakeList.setRollSceneShotFn(this.setRollSceneShot);
    if (this.$refs.videoTakeList)
      this.$refs.videoTakeList.setRollSceneShotFn(this.setRollSceneShot);
  },
  methods: {
    requestMediaPermissions() {
      requestMediaPermissions(this.permissionsNeeded)
        .then(() => {
          this.permissionGranted = true;
          window.location.reload();
        })
        .catch(() => {
          //    alert("Error getting permissions");
        });
    },
    startTimer() {
      this.activationTimer = window.setInterval(() => {
        this.timeRemaining = parseInt(this.activeUntil * 1000) - new Date();
        if (this.timeRemaining <= 0) {
          this.$refs.participantList.showActions = false;
          clearInterval(this.activationTimer);
          this.roomActivated = false;
          this.activationTimer = null;
          let endOfSessionButton = document.querySelector("#endOfSessionButton")
          if (endOfSessionButton) endOfSessionButton.classList.add("hidden")
          let suspendSessionButton = document.querySelector("#suspendSessionButton")
          if (suspendSessionButton) {
            suspendSessionButton.classList.add("hidden")
          }




          //disconnect
        } else {
          // this is called every second
          if (this.$refs.participantList)
            this.$refs.participantList.showActions = true;
            hooksManager.emit("participants--new-participant")
        }
        if (parseInt(this.timeRemaining / 1000) === 300) {
          localNotify('Time is running out');
          this.showExpirationModal = true
        }
      }, 1000)
    },
    activateRoom(token_id) {
      var self = this;
      axios.post('/rooms/activate', {room_id: this.room.id, tk_id: token_id, authenticity_token: authenticity_token}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(response => {
        this.showExpirationModal = false;
        this.showActivationModal = false;
        this.roomActivated = true;
        if (response.data.activated) {
          this.activeUntil = new Date(response.data.data.active_until).getTime() / 1000;
          window.activeUntil = this.activeUntil
          commandsManager.sendAllCommand('active_until', {activeUntil: parseInt(window.activeUntil * 1000) - new Date()})
          this.$root.$emit('roomActivated')
          $("#endOfSessionButton").removeClass("hidden");
          let suspendSessionButton = document.querySelector("#suspendSessionButton")
          if (suspendSessionButton) {
            suspendSessionButton.classList.remove("hidden")
          }

          this.startTimer();
        }
      }).catch(error => {
        alert(error.message)
      })
    },
    toggleSuspendSession(){
      if (this.isSuspended){
        this.showResumeSessionModal = true;
      } else {
        this.suspendSession()
      }
    },
    suspendSession(){
      // do a post to rooms/:key/suspend
      fetch("/rooms/"+this.room.key+"/suspend", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.authenticity_token
        },
        body: JSON.stringify({room_id: this.room.id})
      }).then(response => {
        if (response.ok) {
          this.isSuspended = true
          commandsManager.sendAllCommand("set_suspend_room", {is_suspended: this.isSuspended})
          this.updateSessionButtonUI(this.isSuspended)
        }
      })
    },
    unsuspendSession(notifyParticipants){
      // do a post to rooms/:key/suspend
      fetch("/rooms/"+this.room.key+"/unsuspend", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.authenticity_token
        },
        body: JSON.stringify({
          room_id: this.room.id,
          notify_all: notifyParticipants,
        })
      }).then(response => {
        if (response.ok) {
          this.isSuspended = false
          this.showResumeSessionModal = false;
          commandsManager.sendAllCommand("set_suspend_room", {is_suspended: this.isSuspended})
          this.updateSessionButtonUI(this.isSuspended)
        }
      })
    },

    updateSessionButtonUI(isSuspended){
      let suspendSessionButton = document.querySelector("#suspendSessionButton")
      if (suspendSessionButton) {
        suspendSessionButton.innerHTML = isSuspended ? "Resume session" : "Pause session"
        suspendSessionButton.classList.toggle("btn-red", !isSuspended);
        suspendSessionButton.classList.toggle("btn-green", isSuspended);
      }

    },
    showSettingsModal() {
      this.permissionStep = 2;
      refreshDevices();
    },
    checkBrowser() {
      if (detectBrowser(window).browser === 'chrome' && detectBrowser(window).version >= 81
          // disabling firefox support
          // || (detectBrowser(window).browser == 'firefox' && detectBrowser(window).version >= 78)
      ) {
        // place only chrome stuff here
      } else {
        $("#browserNotCompatible").removeClass("hidden")
        $("#browserName").html(detectBrowser(window).browser + " " + detectBrowser(window).version)
      }
    },
    setRollSceneShot(roll, scene, shot){
      this.$refs.viewport.setRollSceneShot(roll, scene, shot);
    },
   
    hideSettingsModal(){
      this.showPermissionModal = false;
    },
    showManageParticipantsModal(){
      this.showParticipantsModal = true;
      if (this.$refs.manageParticipantsModal)
        this.$refs.manageParticipantsModal.loadParticipants();
    },
  },
    watch: {
	  isMirrorPlus: function(oldValue, newValue){
    // disable dark mode
		// document.querySelector('html').classList.toggle('dark')
	    commandsManager.sendAllCommand('set_mirror_plus', {is_mirror_plus: this.isMirrorPlus})
	  },

    activeTab: function(newValue, oldValue){
      if (newValue == "settings") {
        this.$refs.settings.onAppear();
      }
      }
  },
}
</script>
<style lang="">

</style>
